// src/components/AppFooter.js
import React from 'react';

function AppFooter() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white border-t border-gray-200 mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="md:flex md:items-center md:justify-between">
          <div className="flex items-center">
            <div className="text-2xl font-bold text-blue-600 flex items-center">
              <span className="mr-2">🧘‍♀️</span>
              PilatesPlanner
            </div>
          </div>
          
          <div className="mt-8 md:mt-0">
            <div className="flex space-x-6 md:justify-end">
              <button onClick={() => {}} className="text-gray-400 hover:text-gray-500">
                <span className="sr-only">Terms of Service</span>
                <span className="text-sm">Terms</span>
              </button>
              <button onClick={() => {}} className="text-gray-400 hover:text-gray-500">
                <span className="sr-only">Privacy Policy</span>
                <span className="text-sm">Privacy</span>
              </button>
              <button onClick={() => {}} className="text-gray-400 hover:text-gray-500">
                <span className="sr-only">Contact Us</span>
                <span className="text-sm">Contact</span>
              </button>
            </div>
          </div>
        </div>
        
        <div className="mt-8 border-t border-gray-200 pt-8 md:flex md:items-center md:justify-between">
          <div className="text-sm text-gray-500">
            &copy; {currentYear} PilatesPlanner. All rights reserved.
          </div>
          <div className="mt-4 md:mt-0">
            <p className="text-sm text-gray-500">
              Always consult with a fitness professional before starting a new exercise program.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default AppFooter;